import React, {InputHTMLAttributes, ReactNode} from 'react'
import {InputTextContainer, LabelHeader} from "./styles";
import {isValidString} from "../../utils";
import {Tooltip} from "../Tooltip";

interface InputTextProps extends InputHTMLAttributes<HTMLInputElement> {
    helperText?: string;
    status?: 'danger' | 'warning' | 'success' | 'normal';
    label?: string;
    icon?: ReactNode
    tooltipText?: string
}

export const  InputText = ({
    helperText,
    status = 'normal',
    label,
    icon,
    tooltipText,
    ...inputProps
}: InputTextProps) => {
    return <InputTextContainer status={status}>
        <label htmlFor={inputProps.id}>
            <LabelHeader>
                {isValidString(label) && label}
                {isValidString(tooltipText) && <Tooltip text={tooltipText as string}/>}
            </LabelHeader>
            <input {...inputProps}/>
            {icon && icon}
        </label>
        {isValidString(helperText) && <small>{helperText}</small>}
    </InputTextContainer>
}
